module.exports = __webpack_public_path__ + "img/top7_img1.760a8d85.png";